import { useEffect } from "react";

import { useLanguage } from "@/i18n";
import { buildPortalUrl } from "@/utils/auth";

type PortalRedirectProps = {
  /** Path the portal should return the user to after login. Defaults to "/". */
  from?: string;
};

// Full-page redirect to the centralised Tournated-ID portal. Rendered in place of
// any login screen — guards use it directly so unauthenticated users go straight
// to the portal instead of flashing the local auth layout first.
export const PortalRedirect = ({ from }: PortalRedirectProps) => {
  const [language] = useLanguage();

  useEffect(() => {
    const returnPath = from ?? "/";
    const returnUrl = `${window.location.origin}${returnPath}`;
    const theme = document.documentElement.classList.contains("dark") ? "dark" : "light";

    window.location.replace(buildPortalUrl({ returnUrl, language, theme }));
  }, [from, language]);

  return null;
};
